/**
 * FilterSummary Component
 * Displays current filter selections as text for PDF export headers
 */

import React from 'react';

export function FilterSummary({
  filters = {},
  classLabels,
  dateRange,
  commentBankLabels = [],
  successCriteriaLabels = [],
  rubricLabels = [],
  shortAnswerLabels = [],
}) {
  const formatFilterList = (items) => {
    if (!items || items.length === 0) return 'All';
    return items.join(', ');
  };

  const hasActiveFilters =
    filters?.subjects?.length > 0 ||
    filters?.taskTypes?.length > 0 ||
    filters?.taskIds?.length > 0 ||
    filters?.studentIds?.length > 0;

  return (
    <div className="ci-filter-summary">
      <div className="ci-filter-summary-header">Applied Filters</div>
      <div className="ci-filter-summary-content">
        <div className="ci-filter-summary-row">
          <span className="ci-filter-summary-label">Classes:</span>
          <span className="ci-filter-summary-value">
            {classLabels && classLabels.length > 0 ? formatFilterList(classLabels) : 'All'}
          </span>
        </div>

        {dateRange && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Date Range:</span>
            <span className="ci-filter-summary-value">{dateRange}</span>
          </div>
        )}

        {commentBankLabels.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Specific Comments:</span>
            <span className="ci-filter-summary-value">{formatFilterList(commentBankLabels)}</span>
          </div>
        )}

        {successCriteriaLabels.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Success Criteria:</span>
            <span className="ci-filter-summary-value">{formatFilterList(successCriteriaLabels)}</span>
          </div>
        )}

        {rubricLabels.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Rubrics:</span>
            <span className="ci-filter-summary-value">{formatFilterList(rubricLabels)}</span>
          </div>
        )}

        {shortAnswerLabels.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Short Answers:</span>
            <span className="ci-filter-summary-value">{formatFilterList(shortAnswerLabels)}</span>
          </div>
        )}

        {filters?.subjects && filters.subjects.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Subjects:</span>
            <span className="ci-filter-summary-value">{formatFilterList(filters.subjects)}</span>
          </div>
        )}

        {filters?.taskTypes && filters.taskTypes.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Task Types:</span>
            <span className="ci-filter-summary-value">{formatFilterList(filters.taskTypes)}</span>
          </div>
        )}

        {filters?.taskIds && filters.taskIds.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Tasks:</span>
            <span className="ci-filter-summary-value">{formatFilterList(filters.taskIds)}</span>
          </div>
        )}

        {filters?.studentIds && filters.studentIds.length > 0 && (
          <div className="ci-filter-summary-row">
            <span className="ci-filter-summary-label">Students:</span>
            <span className="ci-filter-summary-value">{formatFilterList(filters.studentIds)}</span>
          </div>
        )}

        {!hasActiveFilters && !dateRange && (
          <div className="ci-filter-summary-note">No additional filters applied</div>
        )}
      </div>
    </div>
  );
}
